import {Button, Col, Input, Row, Table} from "reactstrap";
import React, {Component, Fragment} from "react";

export class UserManagerSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdd: false,
      addChosen: null
    }
  }

  onAdd() {
    this.props.onUpdate && this.props.onUpdate(this.props.users.map((user) => ({
      ...user,
      mngd: user.id === this.state.addChosen.id ? 1 : user.mngd
    })));
    this.setState({showAdd: false, addChosen: null});
  }

  onRemove(id) {
    this.props.onUpdate && this.props.onUpdate(this.props.users.map((user) => ({
      ...user,
      mngd: id === user.id ? 0 : user.mngd
    })));
  }

  onChangePercent(id, percent) {
    this.props.onUpdate && this.props.onUpdate(this.props.users.map((user) => ({
      ...user,
      premPercent: id === user.id ? percent : user.premPercent
    })));
  }

  render() {
    const allUsers = this.props.users || [];

    const selectedUsers = allUsers.filter((user) => {
      return user.mngd === 1;
    });
    const availableUsers = allUsers.filter((user) => {
      return user.mngd === 0 && user.visible === 1;
    });

    return <Fragment>
      {selectedUsers.length > 0 ?
        <Table>
          <thead>
          <tr>
            <th>Agent</th>
            <th>Percent</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          {selectedUsers.map((user) => {
            return <tr key={String(user.id)}>
              <td>{`${user.fname} ${user.lname}${user.visible === 0 ? ` (disabled)` : ""}`}</td>
              <td>{`${user.premPercent}%`}</td>
              <td>
                <Button color={"default"}
                        onClick={() => {
                          const percent = prompt("Enter Percent", user.premPercent);
                          if (percent) {
                            this.onChangePercent(user.id, Number(percent));
                          }
                        }}
                >Edit Percent</Button>
                <Button color={"danger"}
                        onClick={() => this.onRemove(user.id)}>Remove</Button>
              </td>
            </tr>
          })}
          </tbody>
        </Table>
        : <p>No Agents Selected</p>}
      {!this.state.showAdd ?
        <Button onClick={() => this.setState({showAdd: true})}>Add</Button>
        :
        <Fragment>
          <Row>
            <Col xs={12} md={6}>
              <Input type={"select"}
                     defaultValue={""}
                     onChange={(event) => {
                       const chosen = availableUsers.find((user) => user.id === Number(event.target.value));
                       this.setState({addChosen: chosen});
                     }}
              >
                <option value={""} disabled={true}>Select...</option>
                {availableUsers.map((option, index) => {
                  return <option key={index}
                                 value={`${option.id}`}>{`${option.lname},${option.fname}`}</option>
                })}
              </Input>
            </Col>
            <Col xs={12} md={6}>
              <Button onClick={() => this.onAdd()}>Add</Button>
              <Button onClick={() => this.setState({showAdd: false, addChosen: null})}>Cancel</Button>
            </Col>
          </Row>
        </Fragment>
      }
    </Fragment>
  }
}


// WEBPACK FOOTER //
// ./src/containers/Admin/Users/UserManagerSelection.js